<div class="confirmation-dialog">
  <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>

  <div mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message }}</p>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <!-- Als er custom buttons meegegeven zijn -->
    <ng-container *ngIf="data.buttons && data.buttons.length > 0; else defaultButtons">
      <!--button mat-button class="secondary-btn" (click)="dialogRef.close(null)">
        Cancel
      </button-->
      <button *ngFor="let btn of data.buttons" 
              mat-flat-button 
              class="env-btn" 
              (click)="dialogRef.close(btn.value)">
        {{ btn.label }}
      </button>
    </ng-container>

    <!-- Standaard fallback voor alle bestaande schermen -->
    <ng-template #defaultButtons>
      <button mat-button class="secondary-btn" [mat-dialog-close]="false">
        Cancel
      </button>
      <button mat-flat-button class="env-btn" [mat-dialog-close]="true">
        Confirm
      </button>
    </ng-template>
  </div>
</div>